import type { WidgetStep } from './useAppointmentForm';

// Etichette degli step del widget di prenotazione, condivise tra i layout
// (Calcom/Doctolib) per evitare duplicazione. 'product' è mantenuto per
// retrocompatibilità del mapping ma non è più uno step di STEP_ORDER.
export const STEP_LABELS: Record<WidgetStep, string> = {
  service: 'Tipologia di appuntamento',
  product: 'Servizio',
  date: 'Data',
  consultant: 'Consulente',
  slot: 'Orari',
  contact: 'I tuoi dati',
  confirm: 'Conferma',
};

export interface VisibleStepsConfig {
  consultantFilterMode?: string | null;
}

// Sequenza degli step effettivamente mostrati all'utente. Lo step 'consultant'
// è saltato in modalità 'any' (consulente assegnato automaticamente), coerente
// con lo skip in useAppointmentForm.goNext/goBack.
export function buildVisibleSteps(config: VisibleStepsConfig): WidgetStep[] {
  const steps: WidgetStep[] = ['service', 'date'];
  if (config.consultantFilterMode !== 'any') steps.push('consultant');
  steps.push('slot', 'contact');
  return steps;
}
